import React from 'react';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {Filter} from 'presentation/components/Filter';
import {useOdontoFilterByLetter} from './hooks/useOdontoFilterByLetter';

export function OdontoFilterByLetter() {
	const {FILTERED_LIST_BY_CATEGORY, HIDDEN_FILTER_BY_LETTER} = useOdontoFilterByLetter();

	if (HIDDEN_FILTER_BY_LETTER) {
		return null;
	}

	return (
		<Filter.Letter
			dataTagId={AppointmentBookingEnum.CLICK_FILTRAR_ESPECIALIDADE}
			filteredList={FILTERED_LIST_BY_CATEGORY!}
		/>
	);
}
